import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthProvider from "./auth/AuthProvider";
import Layout from "./components/Layout";
import Now from "./pages/Now";
import RunsList from "./pages/RunsList";

// Route-level code splitting (plan §3.5): the heavy pages — Coverage carries
// recharts, run detail the evidence drawer — load on demand, so the first paint
// is not paying for them. Layout supplies the Suspense boundary around the outlet.
const Coverage = lazy(() => import("./pages/Coverage"));
const ExplorationFunnel = lazy(() => import("./pages/ExplorationFunnel"));
const PoliciesList = lazy(() => import("./pages/PoliciesList"));
const PolicyDetail = lazy(() => import("./pages/PolicyDetail"));
const PolicyNew = lazy(() => import("./pages/PolicyNew"));
const RunCompare = lazy(() => import("./pages/RunCompare"));
const RunDetail = lazy(() => import("./pages/RunDetail"));
const TriageWorkbench = lazy(() => import("./pages/TriageWorkbench"));

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Now />} />
          <Route path="/now" element={<Now />} />
          <Route path="/runs" element={<RunsList />} />
          <Route path="/runs/:runId/compare/:otherRunId" element={<RunCompare />} />
          <Route path="/runs/:runId" element={<RunDetail />} />
          <Route path="/triage" element={<TriageWorkbench />} />
          <Route path="/exploration" element={<ExplorationFunnel />} />
          <Route path="/policies/new" element={<PolicyNew />} />
          <Route path="/policies/:policyId" element={<PolicyDetail />} />
          <Route path="/policies" element={<PoliciesList />} />
          {/* Coverage absorbs the green wall, trends and registry. */}
          <Route path="/coverage" element={<Coverage />} />
          <Route path="/green-wall" element={<Navigate to="/coverage" replace />} />
          <Route path="/trends" element={<Navigate to="/coverage" replace />} />
          <Route path="/registry" element={<Navigate to="/coverage" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
